import { render, staticRenderFns } from "./Second.vue?vue&type=template&id=13f93a72&"
import script from "./Second.vue?vue&type=script&lang=ts&"
export * from "./Second.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports